import setWindowScroll from "../../../utils/set-window-scroll";
import setWindowData from "../../../utils/set-window-data";
import setGlobalListeners from "./set-global-listeners";

const onInit = () => {
  // TODO: optimize to not run on every element creation (svelte)
  setWindowData();
  setWindowScroll();
  setGlobalListeners();
};

export default onInit;
